import React from 'react';
// template components
import WidowBlock from '@nmx/template/dist/componentLibrary/components/WidowBlock';
// native components
import AdvisorConnectCardSimplified from '../../../../components/advisorConnectCardSimplified';

export default () => {
  return (
    <AdvisorConnectCardSimplified
      id='fixed-annuity-vs-variable-annuity'
      headingText={<>Find out if a fixed or variable annuity is right <WidowBlock>for you.</WidowBlock></>}
      text='Your advisor will ask deeper questions to help you find the right type of annuity for your goals and budget.'
    />
  );
};

